module.exports = __webpack_public_path__ + "media/images/low_stock_label_on-9367f6ba50083b95a1dba0138ce1bafd.png";